import React from "react";
import { useSelector } from "react-redux";
import { ModalProps } from "antd";

import { NewsletterPropertyBreakdownReportShared } from "../newsletter-property-breakdown-report-shared";
import { Property } from "../generate-newsletter/types";

type Props = ModalProps & { properties: Property[] };
type Modules = "office" | "industrial";

const options: Record<
  Modules | string,
  {
    heading: string;
    method: "getSummaryApiV1OffersSummaryPut" | "getIndustrialListEngApiV1OffersIndustrialListPut";
  }
> = {
  office: { heading: "Generate breakdown report", method: "getSummaryApiV1OffersSummaryPut" },
  serviced_offices: { heading: "Generate breakdown report", method: "getSummaryApiV1OffersSummaryPut" },
  industrial: {
    heading: "Generate Properties breakdown report LNG",
    method: "getIndustrialListEngApiV1OffersIndustrialListPut",
  },
};

export const GenerateBreakdownReport = (props: Props) => {
  const currentModule = useSelector((appState) => appState.offers.currentModule);
  const moduleOptions = options[currentModule];

  return (
    <NewsletterPropertyBreakdownReportShared
      {...props}
      method={moduleOptions.method}
      heading={moduleOptions.heading}
    />
  );
};
